export default {
    title: 'Providers',
    table: {
        header: {
            name: 'Name',
            discount_module: 'Discount module',
        }
    }
}